// Version utility to get current build version
export const getCurrentVersion = (): string => {
  // Try to get version from environment variable first (set during Docker build)
  if (process.env.REACT_APP_VERSION) {
    return process.env.REACT_APP_VERSION;
  }
  
  // Fallback to package.json version (for development)
  try {
    // This will be replaced during build with the actual version
    const packageJson = require('../../package.json');
    return packageJson.version || '2025.01.15.1';
  } catch {
    // Final fallback
    return '2025.01.15.1';
  }
};

// Get version info for display
export const getVersionInfo = () => {
  const version = getCurrentVersion();
  const parts = version.split('.');
  
  return {
    full: version,
    date: parts.slice(0, 3).join('.'),
    build: parts[3] || '1',
    display: `v${version}`
  };
};
